import isInAnyVariant from './isInAnyVariant'

export enum POSSIBLE_VARIANTS {
  B = 'B',
  C = 'C'
}

// CAT-1064
const AB_TEST_LOADING_PAGE = [
  {
    id: 609,
    env: 'shared'
  },
  {
    id: 1209,
    env: 'stage'
  },
  {
    id: 1187,
    env: 'production'
  }
]

export const isInABTestLoadingPageVariantB = () =>
  isInAnyVariant(AB_TEST_LOADING_PAGE)

const AB_TEST_IBAN_TEXT_DELETE = [
  {
    id: 613,
    env: 'shared'
  },
  {
    id: 1214,
    env: 'stage'
  },
  {
    id: 1191,
    env: 'production'
  }
]

export const isInABTestDeleteIBANTextVariantB = () =>
  isInAnyVariant(AB_TEST_IBAN_TEXT_DELETE)

const AB_TEST_CARROT3_LOADING_PAGE_VARIANT_B = [
  {
    id: 625,
    env: 'shared'
  },
  {
    id: 1227,
    env: 'stage'
  },
  {
    id: 1229,
    env: 'production'
  }
]

export const isInCarrot3LoadingVariant = () =>
  isInAnyVariant(AB_TEST_CARROT3_LOADING_PAGE_VARIANT_B)
